<h1 mat-dialog-title class="custom-title">Oops! You are on the wrong site!</h1>
<mat-dialog-content>
    <p>Hi {{ name }},</p>
    <p>Looks like you have found our new login page but we aren't ready for you.</p>
    <p>We will take you back to your normal login page where you may access your account.</p>
</mat-dialog-content>
<mat-dialog-actions class="center">
    <button mat-raised-button color="primary" (click)="goToLoginPage()">Take me to log in page</button>
</mat-dialog-actions>